import { PetAvatar } from "@/components/PetAvatar";

export default function SignUpGate({ onSkip, onSignIn }) {
  const petName = localStorage.getItem('you_pet_name') || 'Your pet';
  const petType = localStorage.getItem('you_pet_type') || 'panda';

  const handleGoogleSignIn = async () => {
    try {
      const { supabase } = await import('@/lib/supabase');
      await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo: window.location.origin }
      });
    } catch (err) {
      console.error('Sign-in failed:', err);
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center',
      justifyContent: 'center', zIndex: 1000, padding: 16,
    }}>
      <div style={{
        background: '#FFFFFF', borderRadius: 4, padding: '32px 24px',
        maxWidth: 380, width: '100%', textAlign: 'center',
        border: '1.5px dashed #CCCCCC', borderLeft: '3px solid #448AFF',
      }}>
        <PetAvatar size={72} state="happy" petType={petType} />

        <p style={{
          fontSize: 20, fontFamily: "'Patrick Hand', cursive",
          color: '#448AFF', margin: '12px 0 8px', fontWeight: 400,
        }}>
          {petName} wants to remember your adventures!
        </p>

        <p style={{
          fontSize: 15, fontFamily: "'Inter', sans-serif",
          color: '#666666', margin: '0 0 20px', lineHeight: 1.5,
        }}>
          Sign in to save your stories, grow {petName}, and earn stars!
        </p>

        <button
          onClick={onSignIn || handleGoogleSignIn}
          style={{
            width: '100%', padding: '14px 24px', borderRadius: 12,
            background: '#448AFF', border: 'none', color: '#FFFFFF',
            fontSize: 16, fontFamily: "'Patrick Hand', cursive",
            fontWeight: 400, cursor: 'pointer', minHeight: 48,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          }}
        >
          <img src="https://www.google.com/favicon.ico" alt="G" style={{ width: 18, height: 18 }} />
          Continue with Google
        </button>

        <div style={{ margin: '16px 0', fontSize: 13, color: '#888888' }}>
          What you'll unlock:
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 16 }}>
          {[
            { emoji: '🎬', label: 'Unlimited Stories' },
            { emoji: '💾', label: 'Save to Library' },
            { emoji: '🐾', label: 'Grow Your Pet' },
            { emoji: '📚', label: 'Access Dream Library' },
            { emoji: '💚', label: 'Share with Friends' },
          ].map(({ emoji, label }) => (
            <span key={label} style={{
              border: '1.5px dashed #448AFF', borderRadius: 20,
              padding: '4px 12px', fontSize: 13, color: '#448AFF',
            }}>
              {emoji} {label}
            </span>
          ))}
        </div>

      </div>
    </div>
  );
}
